import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';
import { HttpEndpoint } from '../http/HttpEndpoint';
import {
    AvailableRoleRuntype,
    MachineTokenCreateRequestRuntype,
    MachineTokenResponseRuntype,
    MachineTokenUpdateRequestRuntype,
} from './machineTokenBackendTypes';

const machineTokenDependentQueries: HttpEndpoint[] = ['GET /machine-tokens', 'GET /machine-tokens/available-roles'];

export const machineTokenEndpoints = {
    'GET /machine-tokens': endpoint({
        description: 'List all machine tokens for the organization',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.object({
            data: z.array(MachineTokenResponseRuntype),
        }),
    }),

    'POST /machine-tokens': endpoint({
        description: 'Create a new machine token',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: MachineTokenCreateRequestRuntype,
        responseBody: z.object({
            data: MachineTokenResponseRuntype,
        }),
        invalidates: machineTokenDependentQueries,
    }),

    'PATCH /machine-tokens/:id': endpoint({
        description: 'Update an existing machine token',
        pathParams: z.object({
            id: z.string(),
        }),
        queryParams: z.undefined(),
        requestBody: MachineTokenUpdateRequestRuntype,
        responseBody: z.object({
            data: MachineTokenResponseRuntype,
        }),
        invalidates: machineTokenDependentQueries,
    }),

    'DELETE /machine-tokens/:id': endpoint({
        description: 'Delete a machine token',
        pathParams: z.object({
            id: z.string(),
        }),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.null(),
        invalidates: machineTokenDependentQueries,
    }),

    'GET /machine-tokens/available-roles': endpoint({
        description: 'Get available roles for machine tokens',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.object({
            data: z.array(AvailableRoleRuntype),
        }),
    }),
};
